module.exports = __webpack_public_path__ + "img/1471908168.afd4ee65.jpg";